import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Conversation } from '../../types/models';

interface ConversationState {
  conversations: Conversation[];
  loading: boolean;
  error: string | null;
  isRecording: boolean;
  isProcessing: boolean;
}

const initialState: ConversationState = {
  conversations: [],
  loading: false,
  error: null,
  isRecording: false,
  isProcessing: false,
};

export const conversationSlice = createSlice({
  name: 'conversation',
  initialState,
  reducers: {
    fetchConversationsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchConversationsSuccess: (state, action: PayloadAction<Conversation[]>) => {
      state.conversations = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchConversationsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addConversation: (state, action: PayloadAction<Conversation>) => {
      state.conversations.push(action.payload);
    },
    startRecording: (state) => {
      state.isRecording = true;
    },
    stopRecording: (state) => {
      state.isRecording = false;
    },
    startProcessing: (state) => {
      state.isProcessing = true;
    },
    stopProcessing: (state) => {
      state.isProcessing = false;
    },
    clearConversations: (state) => {
      state.conversations = [];
    },
    clearConversationError: (state) => {
      state.error = null;
    },
  },
});

export const {
  fetchConversationsStart,
  fetchConversationsSuccess,
  fetchConversationsFailure,
  addConversation,
  startRecording,
  stopRecording,
  startProcessing,
  stopProcessing,
  clearConversations,
  clearConversationError,
} = conversationSlice.actions;

export default conversationSlice.reducer;
